import { useAuth0 } from '@auth0/auth0-react'
import { Button, Grid } from '@mui/material'

export const Logout = () => {
  const { logout } = useAuth0()

  return (
    <Grid container justifyContent="center" marginTop="20px">
      <Button
        onClick={() => {
          logout()
        }}
      >
        Logout
      </Button>
    </Grid>
  )
}
